$(document).ready(function () {
  // MARQUEE
  Marquee3k.init({
    selector: 'marquee3k'
  });

  // FADE IN/OUT
  window.addEventListener("beforeunload", function () {
    $("body").addClass("fade-out");
  });
  window.addEventListener("pageshow", function () {
    setTimeout(function () {
      $("body").removeClass("fade-out");
    }, 250);
  }, false);
  setTimeout(function () {
    $("body").removeClass("fade-out");
  }, 500);

  // LAZY LOADING
  var L = [].slice.call(document.querySelectorAll('.lazy'));
  if ('IntersectionObserver' in window) {
    let o = new IntersectionObserver(function (E, observer) {
      E.forEach(function (e) {
        if (e.isIntersecting) {
          let l = e.target;
          if (l.tagName == 'IMG') {
            setTimeout(function () {
              l.src = l.dataset.src;
            }, 500);
          }
          if (l.tagName == 'VIDEO') {
            var P = l.play();
            if (P !== undefined) {
              P.catch(error => {
                l.controls = true;
                l.classList.add('no-autoplay');
              });
            }
          }
          l.classList.remove('lazy');
          o.unobserve(l);
        }
      });
    });
    L.forEach(function (l) {
      o.observe(l);
    });
  };

  // HANDLE VIDEO PLAY/PAUSE
  const videoToggleButtons = document.querySelectorAll(".toggleButton");
  for (let i = 0; i < videoToggleButtons.length; i++) {
    const video = videoToggleButtons[i].nextElementSibling;
    const toggleButton = videoToggleButtons[i];
    function togglePlay() {
      if (video.paused || video.ended) {
        video.play();
      } else {
        video.pause();
      }
    }
    function updateToggleButton() {
      toggleButton.classList.toggle('play', video.paused || video.ended);
    }
    toggleButton.addEventListener("click", togglePlay);
    video.addEventListener("click", togglePlay);
    video.addEventListener("play", updateToggleButton);
    video.addEventListener("pause", updateToggleButton);
  }

  // HOME SWIPER
  var homeSwiper = new Swiper('.home-intro', {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
      renderFraction: function (currentClass, totalClass) {
        return '<span class="' + currentClass + '"></span>' + '<span class="' + totalClass + '"></span>';
      },
    },
  });

  function initGeneralSwipers() {
    const allHomeSwipers = document.querySelectorAll('.slider-items-swipper');
    allHomeSwipers.forEach((swiper, index) => {
      index = index + 1;
      swiper.classList.add(`general-swiper-${index}`);

      new Swiper(`.general-swiper-${index}`, {
        direction: 'horizontal',
        loop: true,
        slidesPerView: 2,
        spaceBetween: 10,
        navigation: {
          nextEl: `.general-swiper-${index} .swiper-button-next`,
          prevEl: `.general-swiper-${index} .swiper-button-prev`,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
          },

        }
      });
    });
  }

  initGeneralSwipers();

  function initSwiperWithThumbnails() {

    const swiperWithThumbnailsContainer = document.querySelectorAll('.swiper-with-thumbnails-container');

    swiperWithThumbnailsContainer.forEach((container, index) => {
      index = index + 1;

      const thumbnails = container.querySelector('.swiper-with-thumbnails-thumbnails');
      thumbnails.classList.add(`swiper-with-thumbnails-thumbnails-${index}`);
      const thumbnailsSwiper = new Swiper(`.swiper-with-thumbnails-thumbnails-${index}`, {
        loop: false,
        spaceBetween: 10,
        slidesPerView: 'auto',
        cursor: 'grab',
      });

      const swiper = container.querySelector('.swiper-with-thumbnails-swiper');
      swiper.classList.add(`swiper-with-thumbnails-swiper-${index}`);
      const swiperSwiper = new Swiper(`.swiper-with-thumbnails-swiper-${index}`, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        thumbs: {
          swiper: thumbnailsSwiper,
        },
      });
    });
  }

  initSwiperWithThumbnails();

  // SHOPIFY MONEY FORMAT HANDLER
  Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) { return 0; }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

  // FOOTER HEIGHT
  function updateFooterHeight() {
    var footerHeight = $('footer').outerHeight();
    document.documentElement.style.setProperty('--footer-height', footerHeight + 'px');
  }
  updateFooterHeight();
  $(window).resize(function () {
    updateFooterHeight();
  });

  // HEADER MOBILE MENU
  var menuOpen = document.querySelector('#open-mobile-nav');
  var menuClose = document.querySelector('#close-mobile-nav');
  var menu = document.querySelector('#mobile-nav-dialog');
  menuOpen.addEventListener('click', function () {
    menu.showModal();
  });
  menuClose.addEventListener('click', function () {
    menu.close();
  });

  // HEIGHT VIEWPORT
  const windowHeight = document.documentElement.clientHeight;
  document.documentElement.style.setProperty('--viewport-height', `${windowHeight}px`);
  $(window).on("resize", function () {
    // HEIGHT VIEWPORT
    const windowHeight = document.documentElement.clientHeight;
    document.documentElement.style.setProperty('--viewport-height', `${windowHeight}px`);

    // Close mobile nav dialog when resizing to desktop
    const mobileNavDialog = document.getElementById('mobile-nav-dialog');
    if (mobileNavDialog && mobileNavDialog.hasAttribute('open')) {
      const windowWidth = window.innerWidth;
      // Close if window width is greater than mobile breakpoint (assuming 768px or similar)
      if (windowWidth > 1024) {
        mobileNavDialog.close();
        document.body.classList.remove('mobile-nav-open');
      }
    }
    checkTextOverflow();
  });

  const doc = document.documentElement
  doc.style.setProperty('--app-height', `${window.innerHeight}px`);

  // ADD TARGET TO TAG
  const isExternalURL = (url) => new URL(url).origin !== location.origin;
  var aTags = document.querySelectorAll('a');
  for (var i = 0; i < aTags.length; i++) {
    if (isExternalURL(aTags[i].href)) {
      aTags[i].target = '_blank';
      aTags[i].rel = 'noopener noreferrer';
    }
  }

  const videos = document.querySelectorAll('.cover-video');
  videos.forEach(video => {
    const mobilePoster = video.dataset.mobilePoster;

    if (mobilePoster) {
      const mediaQuery = window.matchMedia('(max-width: 1239px)');

      function handleMediaChange(e) {
        video.poster = e.matches ? mobilePoster : video.dataset.defaultPoster;
      }

      video.dataset.defaultPoster = video.poster;
      mediaQuery.addListener(handleMediaChange);
      handleMediaChange(mediaQuery);
    }
  });

  const moreDescriptionButton = document.querySelectorAll('.more-description');

  function checkTextOverflow() {
    moreDescriptionButton.forEach(button => {
      const buttonParent = button.parentElement;
      const productDescription = buttonParent.querySelector('.description-to-limit');
      if (productDescription.classList.contains('limit-lines-8')) {
        const isOverflowing = productDescription.scrollHeight > productDescription.clientHeight;
        if (isOverflowing) {
          button.classList.remove('hidden');
        } else {
          button.classList.add('hidden');
        }
      }
    });
  }
  moreDescriptionButton.forEach(button => {
    const buttonParent = button.parentElement;
    const productDescription = buttonParent.querySelector('.description-to-limit');
    checkTextOverflow();

    button.addEventListener('click', () => {
      if (productDescription.classList.contains('limit-lines-8')) {
        productDescription.classList.remove('limit-lines-8');
        button.textContent = button.dataset.lessText || 'Less';
      } else {
        productDescription.classList.add('limit-lines-8');
        button.textContent = button.dataset.moreText || 'More';
      }
    });
  });

  const productImageButtonSectionButton = document.querySelectorAll('.product-image-button-section-button');
  productImageButtonSectionButton.forEach(button => {
    // Store the original button text if not already stored
    if (!button.dataset.originalText) {
      button.dataset.originalText = button.textContent.trim();
      button.dataset.originalWidth = button.clientWidth;
    }

    button.addEventListener('click', () => {
      const productImageButtonSectionImageText = button.parentElement.parentElement.querySelector('.product-image-button-section-image-button');
      const isOpen = productImageButtonSectionImageText.classList.contains('open-image-text');

      if (isOpen) {
        productImageButtonSectionImageText.classList.remove('open-image-text');
        button.textContent = button.dataset.originalText;
        button.style.width = '';
      } else {
        productImageButtonSectionImageText.classList.add('open-image-text');
        button.style.width = button.dataset.originalWidth + 'px';
        button.textContent = 'X';
      }
    });
  });

  // SUMMARY TOGGLE FUNCTIONALITY
  const summaryContainers = document.querySelectorAll('.summary-container');
  summaryContainers.forEach(container => {
    const summaryItems = container.querySelectorAll('.summary-item');
    const summaryItemsLength = summaryItems.length;
    summaryItems.forEach(details => {
      const summary = details.querySelector('summary');
      const toggleButton = details.querySelector('.summary-toggle-button');
      const buttonSpan = toggleButton.querySelector('span');
      const titleSpan = details.querySelector('.summary-title');

      // Prevent default summary behavior when clicking the title
      titleSpan.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });

      // Handle button clicks to toggle the details
      toggleButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const isOpen = details.hasAttribute('open');

        if (isOpen) {
          details.removeAttribute('open');
          buttonSpan.textContent = '+';
        } else {
          // Close all other summaries first
          summaryItems.forEach(otherDetails => {
            if (otherDetails !== details) {
              otherDetails.removeAttribute('open');
              const otherButtonSpan = otherDetails.querySelector('.summary-toggle-button span');
              if (otherButtonSpan) {
                otherButtonSpan.textContent = '+';
              }
            }
          });

          // Open the clicked summary
          details.setAttribute('open', '');
          buttonSpan.textContent = '−';
        }
      });

      if (summaryItemsLength == 1) {
        const detailsDescription = details.querySelector('.summary-description');
        
        // Check if the text is being truncated by CSS
        const isOverflowing = detailsDescription.scrollHeight > detailsDescription.clientHeight;
        let lineCount;
        
        if (isOverflowing) {
          lineCount = 6;
        } else {
          const computedStyle = window.getComputedStyle(detailsDescription);
          
          // Get actual line height by measuring a single line
          const tempSpan = document.createElement('span');
          tempSpan.style.cssText = `
            position: absolute;
            visibility: hidden;
            font-family: ${computedStyle.fontFamily};
            font-size: ${computedStyle.fontSize};
            line-height: ${computedStyle.lineHeight};
            white-space: nowrap;
          `;
          tempSpan.textContent = 'Test';
          document.body.appendChild(tempSpan);
          
          const actualLineHeight = tempSpan.offsetHeight;
          document.body.removeChild(tempSpan);
          
          // Subtract padding from total height to get content height
          const paddingTop = parseInt(computedStyle.paddingTop);
          const paddingBottom = parseInt(computedStyle.paddingBottom);
          const contentHeight = detailsDescription.scrollHeight - paddingTop - paddingBottom;
          
          lineCount = Math.ceil(contentHeight / actualLineHeight);
        }

        // If more than 5 lines, proceed with the action
        if (lineCount <= 5) {
          details.setAttribute('open', '');
          buttonSpan.textContent = '−';
        }
      }

      // Prevent the summary element from toggling when clicked
      summary.addEventListener('click', (e) => {
        e.preventDefault();
      });
    });
  });
  function initProductBottomBar() {
    const bottomBar = document.querySelector('.product-bottom-bar');

    if (!bottomBar) return;

    const productIntroSection = document.querySelector('.product-shop-intro-section');
    const footer = document.querySelector('footer');

    function handleScroll() {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;

      // Check if footer is visible
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        const isFooterVisible = footerRect.top < windowHeight;

        if (isFooterVisible) {
          // Hide bottom bar when footer is visible
          bottomBar.classList.remove('show');
          return;
        }
      }

      if (productIntroSection) {
        // Get the bottom position of the product intro section
        const introSectionRect = productIntroSection.getBoundingClientRect();
        const introSectionBottom = introSectionRect.top + scrollPosition + introSectionRect.height;

        // Show bottom bar when scrolled past the product intro section
        if (scrollPosition > introSectionBottom) {
          bottomBar.classList.add('show');
        } else {
          bottomBar.classList.remove('show');
        }
      } else {
        // If product intro section doesn't exist, always show the bottom bar
        bottomBar.classList.add('show');
      }
    }

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Add resize event listener
    window.addEventListener('resize', handleScroll);

    // Call once on page load to check initial state
    handleScroll();
  }
  initProductBottomBar();

  const mainNavLinksWithChilds = document.querySelectorAll('.has-childs');
  mainNavLinksWithChilds.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
    link.addEventListener('mouseenter', (e) => {
      e.preventDefault();
      const linkParent = link.parentElement;
      const isOpen = linkParent.classList.contains('show');
      const headerContainerDesktop = document.querySelector('#main-navigation .header-container-desktop');

      if (isOpen) {
        // Close this item
        // linkParent.classList.remove('show');
        // link.classList.remove('selected-menu-item');
        // headerContainerDesktop.classList.remove('show-childs');
      } else {
        // Close all other items first
        mainNavLinksWithChilds.forEach(otherLink => {
          const otherParent = otherLink.parentElement;
          if (otherParent !== linkParent) {
            otherParent.classList.remove('show');
            otherLink.classList.remove('selected-menu-item');

          }
        });

        // Open the clicked item
        linkParent.classList.add('show');
        link.classList.add('selected-menu-item');
        headerContainerDesktop.classList.add('show-childs');
      }
    });

    // Handle mouseleave for the entire navigation area
    const mainNavigation = document.querySelector('#main-navigation');
    if (mainNavigation) {
      mainNavigation.addEventListener('mouseleave', (e) => {
        const headerContainerDesktop = document.querySelector('#main-navigation .header-container-desktop');

        // Close all navigation items
        mainNavLinksWithChilds.forEach(navLink => {
          const navLinkParent = navLink.parentElement;
          navLinkParent.classList.remove('show');
          navLink.classList.remove('selected-menu-item');
        });

        // Hide child elements
        headerContainerDesktop.classList.remove('show-childs');
      });
    }
  });

  const subMenuContainers = document.querySelectorAll('#main-navigation .sub-menu-container');
  subMenuContainers.forEach(container => {
    const secondaryNavLinksWithChilds = container.querySelectorAll('.has-tertiary-childs');
    secondaryNavLinksWithChilds.forEach(link => {
      link.addEventListener('mouseenter', (e) => {
        const linkParent = link.parentElement;
        secondaryNavLinksWithChilds.forEach(otherLink => {
          const otherParent = otherLink.parentElement;
          if (otherParent !== linkParent) {
            otherParent.classList.remove('show');
            otherLink.classList.remove('selected-menu-item');
          }
        });
        linkParent.classList.add('show');
        link.classList.add('selected-menu-item');
      });
    });
  });

  // Mobile top row navigation functionality
  const mobileTopRowNavLinks = document.querySelectorAll('.mobile-top-row-nav-link');
  const mobileTopRowNavItems = document.querySelectorAll('.mobile-top-row-nav-li');

  mobileTopRowNavLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      // Remove selected class from all items
      mobileTopRowNavItems.forEach(item => {
        item.classList.remove('show');
        const itemLink = item.querySelector('.mobile-top-row-nav-link');
        if (itemLink) {
          itemLink.classList.remove('selected-menu-item');
        }
      });

      // Add selected class to clicked item
      const clickedItem = link.closest('.mobile-top-row-nav-li');
      if (clickedItem) {
        clickedItem.classList.add('show');
        link.classList.add('selected-menu-item');
      }
    });
  });
  function addToCartButtonPriceHandler() {
    const addToCartButton = document.querySelector('button[name=add]');
    if (!addToCartButton) return;
    const addToCartButtonPrice = addToCartButton.querySelector('.addtoca-button-price');
    if (!addToCartButtonPrice) return;
    const addToCartButtonPriceText = addToCartButtonPrice.textContent;

    function removeSellingPlanDescription() {
      const appstleSellingPlanDescriptionAll = document.querySelectorAll('.appstleSellingPlanDescription');
      appstleSellingPlanDescriptionAll.forEach(description => {
        description.classList.remove('show');
      });
    }

    function addOriginalPriceToSubscriptionWidget() {
      const appstleSubscriptionWrapperOption = document.querySelector('.payAsYouGoPlansDropdownWrapper');
      if (!appstleSubscriptionWrapperOption) return;
      const sellingPlanSpan = appstleSubscriptionWrapperOption.querySelectorAll('.sellingplan');
      if (!sellingPlanSpan) return;
      sellingPlanSpan.forEach(span => {
        const existingOriginalPrice = span.querySelector('.original-price');
        if (existingOriginalPrice) return; // Skip if already exists
        
        const originalPriceSpan = document.createElement('span');
        originalPriceSpan.classList.add('original-price');
        originalPriceSpan.textContent = addToCartButtonPriceText;
        
        span.appendChild(originalPriceSpan);
      });
    }

    function addClosingMethodToSubscriptionWidget() {
      const appstleSubscriptionWrapperOption = document.querySelector('.payAsYouGoPlansDropdownWrapper');
      if (!appstleSubscriptionWrapperOption) return;
      
      // Check if event listener has already been added
      if (appstleSubscriptionWrapperOption.hasAttribute('data-click-listener-added')) return;
      
      appstleSubscriptionWrapperOption.addEventListener('click', (e) => {
        if (appstleSubscriptionWrapperOption.classList.contains('appstle-active-option')) {
          const appstleSubscribeOptionContainer = appstleSubscriptionWrapperOption.querySelector('.appstle_subscribe_option');
          if (!appstleSubscribeOptionContainer) return;
          appstleSubscriptionWrapperOption.classList.toggle('hide-subs-options');
        }
      });
      
      // Mark that the event listener has been added
      appstleSubscriptionWrapperOption.setAttribute('data-click-listener-added', 'true');
    }


    document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanDeSelected', function() {
      addToCartButtonPrice.textContent = addToCartButtonPriceText;
      removeSellingPlanDescription();
      const appstleSubscriptionWrapperOption = document.querySelector('.payAsYouGoPlansDropdownWrapper');
      if (!appstleSubscriptionWrapperOption) return;
      appstleSubscriptionWrapperOption.classList.remove('hide-subs-options');
    });

    document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanSelected', function() {
      addOriginalPriceToSubscriptionWidget();
      addClosingMethodToSubscriptionWidget();
      const appstleSubscriptionWrapperOption = document.querySelector('.payAsYouGoPlansDropdownWrapper');
      if (!appstleSubscriptionWrapperOption) return;
      const appstleSubscribeOptionContainer = appstleSubscriptionWrapperOption.querySelector('.appstle_subscribe_option');
      if (!appstleSubscribeOptionContainer) return;
      const selectedSellingPlanInput = appstleSubscribeOptionContainer.querySelector('input[name=selling_plan_radio]:checked');
      if (!selectedSellingPlanInput) return
      const selectedSellingPlanLabel = selectedSellingPlanInput.parentElement.querySelector('label');
      if (!selectedSellingPlanLabel) return;
      const selectedSellingPlanPrice = selectedSellingPlanLabel.querySelector('.transcy-money');
      if (!selectedSellingPlanPrice) return;
      addToCartButtonPrice.textContent = selectedSellingPlanPrice.textContent;
      removeSellingPlanDescription();
      const selectedSellingPlanDescription = selectedSellingPlanInput.parentElement.parentElement.querySelector('.appstleSellingPlanDescription');
      if (!selectedSellingPlanDescription) return;
      selectedSellingPlanDescription.classList.add('show');
    });
  }
  addToCartButtonPriceHandler();
  

  // Cookie utility functions
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  };

  const setCookie = (name, value, days = 365) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  };

  function closeNewsletterPopup() {
    const newsletterPopup = document.querySelector('#newsletter-popup');
    if (newsletterPopup) {
      setCookie('newsletter_confirmed', 'dismissed', 1);
      newsletterPopup.close();
    }
  }

  const newsletterPopup = document.querySelector('#newsletter-popup');
  if (newsletterPopup) {
    const closeButton = newsletterPopup.querySelector('.close-button');
    
    // Check if newsletter cookie exists
    const newsletterCookie = getCookie('newsletter_confirmed');
    
    // Only show modal if user hasn't dismissed it before
    if (!newsletterCookie) {
      // Show modal after 2 seconds delay
      setTimeout(() => {
        newsletterPopup.showModal();
      }, 2000);
    }
    
    // Handle close button click
    closeButton.addEventListener('click', closeNewsletterPopup);
    
    // Handle clicking outside the popup
    newsletterPopup.addEventListener('click', (e) => {
      if (e.target === newsletterPopup) {
        closeNewsletterPopup();
      }
    });
  }
});